<script>
export default {
  name: 'ProNav',
  computed: {
    auth () {
      return this.$store.state.auth
    },
    user () {
      return this.$store.state.user
    },
    isAdmin () {
      return this.user.user_type.includes('ADMIN')
    },
    dashboardLink () {
      return this.isAdmin ? 'AdminMain' : 'GuardianDashboard'
    },
  },
  methods: {
    logout () {
      this.$store.commit('logout')
    },
    toTypeform () {
      window.location.href = "https://sbcs.typeform.com/to/ejeLK10c"
    },
  },
}
</script>

<template lang="pug">
  .pro-nav-main
    .pro-nav-container
      .title-holder
        .logo(
          @click='$router.push({name: "Home"})'
        )
          img(
            src='@/assets/img/sbcs_logo.png'
          )
      .actions
        .pro-button.login.major(
          @click='toTypeform()'
        ) Sign Up
        //- router-link(
        //-   v-if='auth'
        //-   :to='{name: dashboardLink}'
        //- ) 
        //-   .pro-button.minor Dashboard
        //- .pro-button.logout.minor(
        //-   v-if='auth'
        //-   @click='logout'
        //- ) Logout
        //- .pro-button.login.major(
        //-   v-else
        //-   @click=`$modals.show({name: 'login'})`
        //- ) Login
</template>

<style lang="sass" scoped>
  @import '$vars'
  @import '$styles/form'
  .pro-nav-main
    position: relative
    z-index: $nav-index
    box-shadow: 0 0 4px 0 rgba(195, 195, 195, .35)
    .pro-nav-container
      height: $nav-height
      background-color: white
      display: grid
      grid-template-columns: auto auto
      align-items: center
      padding: 0 24px
      box-sizing: border-box
      // border-bottom: thin solid black
      .title-holder
        width: fit-content
        .logo
          width: 50vw
          max-width: 204px
          cursor: pointer
          > img
            width: 100%
      .actions
        justify-self: end
        grid-column-gap: 1rem
        > *
          cursor: pointer
          display: inline-block
          margin-left: 1rem
        a
          text-decoration: none
      @media(max-width:700px)
        padding: 0 0.5rem
        .title-holder
          .logo
            width: 33vw

</style>
